import actions from '../../actionTypes';

export default (org) => {
  return {
    type: actions.SET_ORG,
    org
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/setOrg.js